import { useEffect, useRef, useState, useCallback } from 'react';
import { useOnboardingStore } from '../../store/useOnboardingStore';
import { Link } from 'react-router-dom';
import logo from "../../assets/images/logo_2.png";
import React from 'react';

/* ═══════════════════════════════════════════════════
   INJECT STYLES
═══════════════════════════════════════════════════ */
const injectStyles = () => {
  if (document.getElementById("obg-styles")) return;
  const s = document.createElement("style");
  s.id = "obg-styles";
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    @keyframes obg-shimmer { 0%{background-position:200% center} 100%{background-position:-200% center} }
    @keyframes obg-in      { from{opacity:0;transform:translateY(4px)} to{opacity:1;transform:translateY(0)} }

    /* ── Bot keyframes — Step4 se exact same ── */
    @keyframes slideInBot {
      from { opacity:0; transform:translateY(-8px) scale(0.96); }
      to   { opacity:1; transform:translateY(0)    scale(1);    }
    }
    @keyframes botCursor { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes speakBar  { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.9)} }
    @keyframes pulseDot  { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes botBobSvg { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes floatHeartL1 {
      0%  { transform:translate(0,0)         scale(1);    opacity:1; }
      100%{ transform:translate(-14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartL2 {
      0%  { transform:translate(0,0)        scale(0.82); opacity:0.9; }
      100%{ transform:translate(-4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartL3 {
      0%  { transform:translate(0,0)       scale(0.68); opacity:0.8; }
      100%{ transform:translate(9px,-50px) scale(0.22); opacity:0; }
    }
    @keyframes floatHeartR1 {
      0%  { transform:translate(0,0)        scale(1);    opacity:1; }
      100%{ transform:translate(14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartR2 {
      0%  { transform:translate(0,0)       scale(0.82); opacity:0.9; }
      100%{ transform:translate(4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartR3 {
      0%  { transform:translate(0,0)        scale(0.68); opacity:0.8; }
      100%{ transform:translate(-9px,-50px) scale(0.22); opacity:0; }
    }

    /* ── Bot SVG classes — Step4 se exact same ── */
    .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
    .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    /* ── Bot popup wrapper — Step4 se exact same ── */
    .obg-wrap { position:fixed; z-index:99999; animation:slideInBot .28s cubic-bezier(.34,1.2,.64,1) both; }
    .obg-wrap::before { content:''; position:absolute; width:16px; height:9px; background:#c0001a; clip-path:polygon(50% 0%,100% 100%,0% 100%); }
    .obg-wrap.below::before   { top:-9px;    left:24px; }
    .obg-wrap.above::before   { bottom:-9px; left:24px; transform:rotate(180deg); }
    .obg-wrap.toright::before { top:24px;    left:-9px; transform:rotate(-90deg); }
    .obg-wrap.toleft::before  { top:24px;    right:-9px; transform:rotate(90deg); }

    /* ── Bot card — Step4 se exact same ── */
    .obg-card-popup {
      background:#fff; border-radius:14px; border:1px solid rgba(0,0,0,.07); overflow:hidden;
      box-shadow:0 4px 8px rgba(0,0,0,.06),0 18px 52px rgba(0,0,0,.18),0 2px 10px rgba(192,0,26,.1);
    }
    .obg-hd {
      background:linear-gradient(135deg,#c0001a 0%,#8b0000 58%,#5c0000 100%);
      padding:12px 14px 10px; display:flex; align-items:center; gap:10px;
      position:relative; overflow:visible;
    }
    .obg-hd::after {
      content:''; position:absolute; inset:0; pointer-events:none;
      background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),
                       linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px);
      background-size:16px 16px;
    }
    .obg-av   { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .obg-bars { display:flex; align-items:flex-end; gap:2px; position:absolute; bottom:-3px; right:-4px; background:rgba(0,0,0,.3); border-radius:4px; padding:2px 3px; z-index:2; }
    .obg-b    { width:2.5px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .obg-b:nth-child(1){ height:4px;  animation:speakBar .48s .00s ease-in-out infinite; }
    .obg-b:nth-child(2){ height:9px;  animation:speakBar .48s .10s ease-in-out infinite; }
    .obg-b:nth-child(3){ height:6px;  animation:speakBar .48s .20s ease-in-out infinite; }
    .obg-b:nth-child(4){ height:3px;  animation:speakBar .48s .30s ease-in-out infinite; }
    .obg-meta { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .obg-name { font-size:11.5px; font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .obg-sub  { font-size:9.5px; color:rgba(255,255,255,.7); display:flex; align-items:center; gap:4px; margin-top:2px; }
    .obg-dot  { width:5px; height:5px; border-radius:50%; background:#6effa0; box-shadow:0 0 4px rgba(100,255,150,.85); flex-shrink:0; animation:pulseDot 2s ease-in-out infinite; }
    .obg-badge-bot { z-index:1; flex-shrink:0; background:rgba(255,255,255,.16); border:1px solid rgba(255,255,255,.3); border-radius:20px; padding:2px 8px; font-size:10px; font-weight:700; color:#fff; white-space:nowrap; }
    .obg-tag     { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(192,0,26,.1); padding:5px 14px; display:flex; align-items:center; gap:6px; }
    .obg-tag-dot { width:5px; height:5px; border-radius:50%; background:#c0001a; flex-shrink:0; }
    .obg-tag-txt { font-size:9.5px; font-weight:800; color:#c0001a; letter-spacing:.08em; }
    .obg-body { padding:10px 14px 8px; }
    .obg-msg  { font-size:13px; line-height:1.62; color:#1a1a1a; word-break:break-word; margin:0; }
    .obg-msg strong { color:#c0001a; font-weight:800; }
    .obg-cur  { display:inline-block; width:2px; height:13px; background:#c0001a; border-radius:2px; margin-left:2px; vertical-align:middle; animation:botCursor .65s ease-in-out infinite; }
    .obg-ft   { padding:8px 14px 11px; display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; }
    .obg-dots { display:flex; gap:4px; align-items:center; }
    .obg-d    { width:6px; height:6px; border-radius:50%; background:#e0e0e0; transition:all .3s; }
    .obg-d.on { width:18px; border-radius:999px; background:linear-gradient(90deg,#c0001a,#8b0000); }
    .obg-skip-bot { background:none; border:none; cursor:pointer; font-size:11px; color:#c0c0c0; padding:4px 6px; border-radius:6px; transition:all .18s; white-space:nowrap; }
    .obg-skip-bot:hover { background:#f0f0f0; color:#888; }
    .obg-next { background:linear-gradient(135deg,#c0001a,#8b0000); color:#fff; border:none; border-radius:8px; padding:7px 16px; font-size:12px; font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 3px 12px rgba(192,0,26,.32); transition:all .18s; white-space:nowrap; }
    .obg-next:hover  { transform:translateY(-1px); box-shadow:0 5px 16px rgba(192,0,26,.46); }
    .obg-next:active { transform:scale(.97); }

    /* ── Page background — Step4 se EXACT same ── */
    .obg-section { background:#f8f5f0 !important; min-height:100vh !important; }

    /* ── Progress bars — Step4 se exact same ── */
    .obg-prog-wrap { display:flex !important; gap:5px !important; margin-top:10px !important; }
    .obg-prog-bar  { height:4px !important; border-radius:999px !important; flex:1 !important; background:#e2e8f0 !important; }
    .obg-prog-bar.done   { background:linear-gradient(90deg,#c0001a,#8b0000) !important; }
    .obg-prog-bar.active { background:linear-gradient(90deg,#e0001f,#c0001a) !important; animation:obg-shimmer 2s linear infinite !important; background-size:200% auto !important; }

    /* ── Almost there badge ── */
    .obg-almost {
      display:inline-flex !important; align-items:center !important; gap:8px !important;
      background:linear-gradient(135deg,#fff5f5,#fee2e2) !important;
      border:1.5px solid rgba(192,0,26,.25) !important; border-radius:999px !important;
      padding:7px 18px 7px 12px !important;
      font-size:12.5px !important; font-weight:700 !important; color:#c0001a !important;
      font-family:'Inter',sans-serif !important; margin-top:12px !important;
      box-shadow:0 2px 8px rgba(192,0,26,.1) !important; white-space:nowrap !important;
    }
    .obg-almost-icon {
      width:22px !important; height:22px !important; border-radius:50% !important;
      background:linear-gradient(135deg,#ef4444,#c0001a) !important;
      display:flex !important; align-items:center !important; justify-content:center !important;
      font-size:11px !important; flex-shrink:0 !important;
    }

    /* ── Content cards — Step4 form blocks se same feel ── */
    .obg-card {
      background:#fff !important; border:1.5px solid #e8e3dc !important;
      border-radius:16px !important; padding:22px 24px !important;
      margin-bottom:14px !important;
      box-shadow:0 1px 4px rgba(0,0,0,.04) !important;
      transition:border-color .15s,box-shadow .15s !important;
      position:relative !important;
    }

    /* ── Search input ── */
    .obg-search {
      width:100% !important; height:44px !important;
      border:1.5px solid #d4cfc8 !important; border-radius:10px !important;
      padding:0 14px 0 42px !important; font-size:14px !important;
      font-family:'Inter',sans-serif !important; color:#0f172a !important;
      background:#fafafa url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' fill='none' stroke='%2394a3b8' stroke-width='2' viewBox='0 0 24 24'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cpath d='m21 21-4.35-4.35'/%3E%3C/svg%3E") no-repeat 14px center !important;
      outline:none !important;
      transition:border-color .15s,box-shadow .15s !important; display:block !important;
    }
    .obg-search:focus {
      border-color:#c0001a !important;
      box-shadow:0 0 0 3px rgba(192,0,26,.1) !important;
      background-color:#fff !important;
    }
    .obg-search::placeholder { color:#adb5bd !important; }

    /* ── Category label ── */
    .obg-cat-label {
      font-size:11px !important; font-weight:700 !important; color:#64748b !important;
      letter-spacing:.07em !important; text-transform:uppercase !important;
      margin-bottom:14px !important; display:flex !important; align-items:center !important; gap:8px !important;
      font-family:'Inter',sans-serif !important;
    }
    .obg-cat-line { flex:1 !important; height:1px !important; background:#f1f5f9 !important; }

    /* ── Checkbox items ── */
    .obg-item {
      display:flex !important; align-items:center !important; gap:10px !important;
      padding:9px 12px !important; border-radius:10px !important;
      cursor:pointer !important; transition:background .12s !important; margin-bottom:4px !important;
    }
    .obg-item:hover { background:#f8f5f0 !important; }
    .obg-item.obg-checked { background:#fff5f5 !important; }
    .obg-checkbox {
      width:18px !important; height:18px !important; border-radius:5px !important;
      border:1.5px solid #d4cfc8 !important; flex-shrink:0 !important;
      display:flex !important; align-items:center !important; justify-content:center !important;
      transition:border-color .12s,background .12s !important; background:#fff !important;
    }
    .obg-item.obg-checked .obg-checkbox { border-color:#c0001a !important; background:#c0001a !important; }
    .obg-checkbox-tick { width:10px !important; height:10px !important; display:none !important; }
    .obg-item.obg-checked .obg-checkbox-tick { display:block !important; }
    .obg-item-label {
      font-size:13.5px !important; color:#334155 !important;
      font-family:'Inter',sans-serif !important; font-weight:500 !important;
      cursor:pointer !important; user-select:none !important;
    }
    .obg-item.obg-checked .obg-item-label { color:#c0001a !important; font-weight:600 !important; }

    /* ── Count badge ── */
    .obg-count {
      display:inline-flex !important; align-items:center !important; gap:5px !important;
      background:#fff5f5 !important; border:1px solid rgba(192,0,26,.2) !important;
      border-radius:999px !important; padding:3px 10px !important;
      font-size:11.5px !important; font-weight:700 !important; color:#c0001a !important;
      font-family:'Inter',sans-serif !important; margin-left:auto !important;
    }

    /* ── See more / less ── */
    .obg-see-more {
      display:inline-flex !important; align-items:center !important; gap:5px !important;
      font-size:13px !important; color:#c0001a !important; font-weight:600 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      background:none !important; border:none !important; padding:8px 0 !important;
    }
    .obg-see-more:hover { color:#8b0000 !important; }
    .obg-see-less { color:#94a3b8 !important; }
    .obg-see-less:hover { color:#64748b !important; }

    /* ── Fixed skip step button ── */
    .obg-skip-step {
      position:fixed !important; top:80px !important; right:24px !important;
      display:inline-flex !important; align-items:center !important; gap:5px !important;
      background:#fff !important; border:1.5px solid #e2e8f0 !important;
      border-radius:999px !important; padding:7px 16px !important;
      font-size:13px !important; font-weight:600 !important; color:#64748b !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      text-decoration:none !important; z-index:9000 !important;
      box-shadow:0 2px 8px rgba(0,0,0,.06) !important;
      transition:border-color .15s,color .15s !important;
    }
    .obg-skip-step:hover { border-color:rgba(192,0,26,.4) !important; color:#c0001a !important; }

    /* ── Continue button — Step4 se exact same ── */
    .obg-btn-continue {
      display:inline-flex !important; align-items:center !important; gap:8px !important;
      background:linear-gradient(135deg,#c0001a,#8b0000) !important;
      color:#fff !important; border:none !important; border-radius:10px !important;
      padding:12px 28px !important; font-size:14px !important; font-weight:700 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      letter-spacing:.02em !important; box-shadow:0 3px 14px rgba(192,0,26,.35) !important;
      transition:transform .18s,box-shadow .18s !important;
    }
    .obg-btn-continue:hover  { transform:translateY(-1px) !important; box-shadow:0 5px 20px rgba(192,0,26,.48) !important; }
    .obg-btn-continue:active { transform:scale(.97) !important; }
    .obg-btn-continue.obg-lit { background:linear-gradient(135deg,#e0001f,#c0001a) !important; }

    /* ── Back button — Step4 se exact same ── */
    .obg-btn-back {
      display:inline-flex !important; align-items:center !important; gap:7px !important;
      border:1.5px solid #d0cbc3 !important; background:transparent !important; color:#374151 !important;
      border-radius:10px !important; padding:11px 22px !important;
      font-size:14px !important; font-weight:600 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      transition:border-color .15s,background .15s !important;
    }
    .obg-btn-back:hover { border-color:#94a3b8 !important; }

    .obg-err { font-size:11.5px !important; color:#dc2626 !important; margin-top:6px !important; font-family:'Inter',sans-serif !important; }

    /* ── Mobile: compact, exact-anchor-aligned, overlap-safe bot popup ── */
    @media (max-width: 767px) {
      .obg-wrap        { max-width:calc(100vw - 24px); }
      .obg-card-popup  { border-radius:10px; }
      .obg-hd          { padding:7px 8px 6px; gap:6px; }
      .obg-av svg      { width:34px !important; height:34px !important; }
      .obg-bars        { padding:1px 2px; bottom:-2px; right:-2px; }
      .obg-b           { width:1.5px; }
      .obg-name        { font-size:9px; letter-spacing:.03em; }
      .obg-sub         { font-size:7.5px; }
      .obg-dot         { width:4px; height:4px; }
      .obg-badge-bot   { font-size:8px; padding:1px 5px; }
      .obg-tag         { padding:3px 8px; }
      .obg-tag-dot     { width:4px; height:4px; }
      .obg-tag-txt     { font-size:7.5px; }
      .obg-body        { padding:6px 8px 5px; }
      .obg-msg         { font-size:11px; line-height:1.4; }
      .obg-ft          { padding:5px 8px 7px; }
      .obg-skip-bot    { font-size:9px; padding:2px 4px; }
      .obg-next        { font-size:10px; padding:5px 10px; }
      .obg-d           { width:4px; height:4px; }
      .obg-d.on        { width:12px; }
    }
  `;
  document.head.appendChild(s);
};

/* ═══════════════════════════════════════════════════
   BOT FACE SVG — Step4 se exact same
═══════════════════════════════════════════════════ */
const BotFaceSVG: React.FC = () => (
  <svg width="64" height="64" viewBox="0 0 72 72" fill="none" style={{ overflow: "visible" }}>
    <defs>
      <style>{`
        .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
        .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="ob-bot-bob">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)" />
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)" />
      <circle cx="7"  cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#c0001a" />
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000" />
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white" />
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white" />
      <g className="ob-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b" /></g>
      <g className="ob-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099" /></g>
      <g className="ob-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b" /></g>
      <g className="ob-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099" /></g>
      <path d="M16,46 Q36,60 56,46" stroke="#c0001a" strokeWidth="2.8" strokeLinecap="round" fill="none" />
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <line x1="7"  y1="28" x2="2"  y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="7"  y1="36" x2="2"  y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
    </g>
  </svg>
);

/* ═══════════════════════════════════════════════════
   TYPES
═══════════════════════════════════════════════════ */
type BotSide = "below" | "above" | "toright" | "toleft";
interface StepData { tag: string; plain: string; html: React.ReactNode; sideLg: BotSide; }

// Shared sizing constants — used by BotPopup for its own box AND by the main
// component to size the spacer that pushes page content down so the popup
// never overlaps the next block. Kept small so the bot stays compact and
// hugs the exact anchor field on mobile.
const GAP = 8;
const POPUP_W_MOBILE = 230, POPUP_W_DESKTOP = 310;
const POPUP_H_MOBILE = 130, POPUP_H_DESKTOP = 240;

/* ═══════════════════════════════════════════════════
   BOT STEPS DATA
═══════════════════════════════════════════════════ */
// sideLg is always "below" now — the popup is forced to appear under its anchor
// on every screen size, so this field is kept only to satisfy the StepData type.
const BOT_STEPS: StepData[] = [
  {
    tag:    "STEP 1 OF 3 — SEARCH",
    plain:  "Search for interests that match your personality, hobbies, and lifestyle!",
    html:   <><strong>Search for interests</strong> that match your personality, hobbies, and lifestyle!</>,
    sideLg: "below",
  },
  {
    tag:    "STEP 2 OF 3 — SELECT",
    plain:  "Select all interests that speak to you. No limit — pick as many as you like!",
    html:   <><strong>Select all interests that speak to you.</strong> No limit — pick as many as you like!</>,
    sideLg: "below",
  },
  {
    tag:    "STEP 3 OF 3 — CONTINUE",
    plain:  "Great choices! Press Continue when you are happy with your selections.",
    html:   <>Great choices! Press <strong>Continue</strong> when you are happy with your selections.</>,
    sideLg: "below",
  },
];

const TOTAL_BOT = BOT_STEPS.length;

/* ═══════════════════════════════════════════════════
   BOT POPUP — Step4 se exact same logic
═══════════════════════════════════════════════════ */
interface PopupProps {
  anchorRef: React.RefObject<HTMLDivElement | null>;
  step:      number;
  total:     number;
  data:      StepData;
  onSkip:    () => void;
  onNext:    () => void;
  nextLabel: string;
}

const BotPopup: React.FC<PopupProps> = ({ anchorRef, step, total, data, onSkip, onNext, nextLabel }) => {
  // Mobile gets a smaller card so it never overlaps content or screen edges.
  const isMobileScreen = typeof window !== "undefined" && window.innerWidth < 768;
  const PW      = isMobileScreen ? POPUP_W_MOBILE : POPUP_W_DESKTOP;
  const POPUP_H = isMobileScreen ? POPUP_H_MOBILE : POPUP_H_DESKTOP;

  const [pos,        setPos]        = useState<{ top:number; left:number; width:number } | null>(null);
  const [activeSide, setActiveSide] = useState<BotSide>("below");
  const [displayed,  setDisplayed]  = useState("");
  const [done,       setDone]       = useState(false);
  const [status,     setStatus]     = useState("typing...");
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const retryRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const calcPos = useCallback((): boolean => {
    if (!anchorRef.current) return false;
    const r  = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    if (r.width === 0 && r.height === 0) return false;

    // Popup always appears BELOW the anchor — never above, never to the side.
    // It hugs the anchor's own left edge (not screen-center) so it visually
    // sits directly under the block it refers to.
    if (vw < 768) {
      const popW = Math.min(vw - 16, PW);
      const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));
      let left = r.left;
      left = Math.max(8, Math.min(left, vw - popW - 8));
      setActiveSide("below");
      setPos({ top, left, width: popW });
      return true;
    }

    let left = r.left;
    if (left + PW > vw - 8) left = vw - PW - 8;
    left = Math.max(12, Math.min(left, vw - PW - 12));

    const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));

    setActiveSide("below");
    setPos({ top, left, width: PW });
    return true;
  }, [anchorRef]);

  /* Retry until anchor visible — Step4 identical */
  useEffect(() => {
    let attempts = 0; const MAX = 50;
    if (retryRef.current) clearTimeout(retryRef.current);
    setPos(null);
    const tryCalc = () => {
      const ok = calcPos();
      if (!ok && attempts < MAX) { attempts++; retryRef.current = setTimeout(tryCalc, 80); }
    };
    tryCalc();
    window.addEventListener("resize", calcPos);
    window.addEventListener("scroll", calcPos, true);
    return () => {
      if (retryRef.current) clearTimeout(retryRef.current);
      window.removeEventListener("resize", calcPos);
      window.removeEventListener("scroll", calcPos, true);
    };
  }, [calcPos, step]);

  /* Typewriter — Step4 identical */
  useEffect(() => {
    setDisplayed(""); setDone(false); setStatus("typing...");
    let i = 0;
    const tick = () => {
      if (i <= data.plain.length) { setDisplayed(data.plain.slice(0, i)); i++; timerRef.current = setTimeout(tick, 21); }
      else { setDone(true); setStatus("Online — here to guide you!"); }
    };
    tick();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [data.plain, step]);

  if (!pos) return null;
  const isSide = activeSide === "toright" || activeSide === "toleft";

  return (
    <div className={`obg-wrap ${activeSide}`} style={{ top: pos.top, left: pos.left, width: pos.width, transform: isSide ? "translateY(-50%)" : "none" }}>
      <div className="obg-card-popup" style={{ width: "100%" }}>

        {/* Header */}
        <div className="obg-hd">
          <div className="obg-av">
            <BotFaceSVG />
            <div className="obg-bars"><div className="obg-b"/><div className="obg-b"/><div className="obg-b"/><div className="obg-b"/></div>
          </div>
          <div className="obg-meta">
            <div className="obg-name">SLAMMM GUIDE</div>
            <div className="obg-sub"><div className="obg-dot"/><span>{status}</span></div>
          </div>
          <div className="obg-badge-bot">{step}/{total}</div>
        </div>

        {/* Tag */}
        <div className="obg-tag"><div className="obg-tag-dot"/><div className="obg-tag-txt">{data.tag}</div></div>

        {/* Message */}
        <div className="obg-body">
          {done
            ? <p className="obg-msg">{data.html}</p>
            : <p className="obg-msg">{displayed}<span className="obg-cur"/></p>
          }
        </div>

        {/* Footer */}
        <div className="obg-ft">
          <div className="obg-dots">
            {Array.from({ length: total }).map((_, i) => (
              <div key={i} className={`obg-d${i + 1 === step ? " on" : ""}`}/>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button className="obg-skip-bot" onClick={onSkip}>Skip guide</button>
            <button
              className="obg-next"
              onClick={onNext}
              onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.transform = "translateY(-1px)"; }}
              onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.transform = "none"; }}
            >{nextLabel}</button>
          </div>
        </div>

      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════
   GENRES STEP — MAIN COMPONENT
═══════════════════════════════════════════════════ */
const GenresStep = () => {
  const {
    genres, selectedGenres, fetchGenres, toggleGenre,
    searchQuery, setSearchQuery,
    genresToShow, showMoreGenres, showLessGenres,
    nextStep, prevStep,
  } = useOnboardingStore();

  const [btnLit,  setBtnLit]  = useState(false);
  const [botStep, setBotStep] = useState<number | null>(null);

  /* Track viewport width so the spacer (which pushes content down while the
     bot is showing) matches the popup's actual mobile/desktop size. */
  const [viewportW, setViewportW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const onResize = () => setViewportW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const spacerH = (viewportW < 768 ? POPUP_H_MOBILE : POPUP_H_DESKTOP) + GAP + 8;

  /* Renders an invisible spacer right after a bot-guide anchor. This pushes
     the next block down in normal document flow so the fixed-position bot
     popup (which floats below the anchor) never overlaps/hides it. */
  const BotSpacer = ({ n }: { n: number }) => (
    <div style={{ height: botStep === n ? spacerH : 0, transition: "height .2s ease" }} />
  );

  /* Bot anchor refs */
  const refSearch   = useRef<HTMLDivElement>(null);
  const refGenres   = useRef<HTMLDivElement>(null);
  const refContinue = useRef<HTMLDivElement>(null);

  const getBotRef = (n: number): React.RefObject<HTMLDivElement | null> => {
    if (n === 1) return refSearch;
    if (n === 2) return refGenres;
    return refContinue;
  };

  useEffect(() => {
    injectStyles();
    fetchGenres();
    if (!localStorage.getItem("genresBotSeen")) {
      localStorage.setItem("genresBotSeen", "1");
      setTimeout(() => setBotStep(1), 400);
    }
  }, [fetchGenres]);

  /* Scroll anchor into view — Step4 identical */
  useEffect(() => {
    if (botStep === null) return;
    getBotRef(botStep)?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [botStep]);

  const nextBot = useCallback(() => setBotStep(p => p !== null && p < TOTAL_BOT ? p + 1 : null), []);
  const skipBot = useCallback(() => setBotStep(null), []);

  /* Filtered + grouped genres */
  const filteredGenres = genres.filter((g: any) =>
    g.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const groupedGenres = filteredGenres.reduce((acc: Record<string, typeof genres>, genre: any) => {
    if (!acc[genre.title]) acc[genre.title] = [];
    acc[genre.title].push(genre);
    return acc;
  }, {});

  const handleNext = (e: React.MouseEvent) => { e.preventDefault(); e.stopPropagation(); nextStep(); };
  const handleBack = (e: React.MouseEvent) => { e.preventDefault(); e.stopPropagation(); prevStep(); };
  const handleSkip = (e: React.MouseEvent) => { e.preventDefault(); e.stopPropagation(); nextStep(); };

  return (
    <>
      {/* ── Bot popup — no overlay, same as Step4 ── */}
      {botStep !== null && botStep >= 1 && botStep <= TOTAL_BOT && (
        <BotPopup
          anchorRef={getBotRef(botStep)}
          step={botStep}
          total={TOTAL_BOT}
          data={BOT_STEPS[botStep - 1]}
          onSkip={skipBot}
          onNext={botStep < TOTAL_BOT ? nextBot : skipBot}
          nextLabel={botStep < TOTAL_BOT ? "Next →" : "Done ✓"}
        />
      )}

      {/* ── Navbar — Step4 se exact same ── */}
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container justify-content-center">
          <Link className="navbar-brand" to="/"><img src={logo} alt="Slammm" className="img-fluid"/></Link>
        </div>
      </nav>

      {/* ── Fixed skip step button ── */}
      <button className="obg-skip-step" onClick={handleSkip}>
        Skip this step <i className="fa-solid fa-arrow-right" style={{ fontSize: 11 }}/>
      </button>

      {/* ── Main section — background #f8f5f0 same as Step4 ── */}
      <section className="obg-section onboarding_main_wraper py-60">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1">

              {/* ── Progress header — Step4 style ── */}
              <div className="onboarding_step_top_wraper mb-4">
                <h2 className="mb-1" style={{ fontFamily: "'Inter',sans-serif", fontWeight: 800, letterSpacing: "-.02em" }}>
                  Explore interests that speak to you
                </h2>
                <p style={{ color: "#94a3b8", fontSize: 13, fontFamily: "'Inter',sans-serif", marginBottom: 10 }}>
                  Question 5/6
                </p>
                <div className="obg-prog-wrap">
                  <div className="obg-prog-bar done" />
                  <div className="obg-prog-bar done" />
                  <div className="obg-prog-bar done" />
                  <div className="obg-prog-bar done" />
                  <div className="obg-prog-bar active" />
                  <div className="obg-prog-bar" />
                </div>
                <div className="obg-almost">
                  <div className="obg-almost-icon">🏁</div>
                  You are almost there — one last step!
                </div>
              </div>

              <form
                className="onboarding_form"
                onSubmit={e => e.preventDefault()}
                onKeyDown={e => { if (e.key === "Enter") e.preventDefault(); }}
              >
                {/* ── Search card — Bot Step 1 anchor ── */}
                <div ref={refSearch} className="obg-card">
                  <p style={{ fontSize: 14, color: "#475569", fontFamily: "'Inter',sans-serif", marginBottom: 14, lineHeight: 1.6 }}>
                    Connect with people who share your vibe. Choose the interests that best describe your personality — pick as many as you like.
                  </p>
                  <input
                    type="text"
                    className="obg-search"
                    placeholder="Search interests…"
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                  />
                </div>
                <BotSpacer n={1} />

                {/* ── Genre groups — Bot Step 2 anchor ── */}
                <div ref={refGenres}>
                  {filteredGenres.length > 0 ? (
                    <>
                      {Object.entries(groupedGenres).slice(0, genresToShow).map(([title, items]: [string, any]) => {
                        const mid      = Math.ceil(items.length / 2);
                        const leftCol  = items.slice(0, mid);
                        const rightCol = items.slice(mid);
                        const catChecked = items.filter((i: any) => selectedGenres.includes(i.id)).length;
                        return (
                          <div key={title} className="obg-card">
                            <div className="obg-cat-label">
                              <span>{title}</span>
                              <div className="obg-cat-line"/>
                              {catChecked > 0 && (
                                <span className="obg-count">
                                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"/>
                                  </svg>
                                  {catChecked} selected
                                </span>
                              )}
                            </div>
                            <div className="row g-1">
                              <div className="col-md-6">
                                {leftCol.map((item: any) => (
                                  <div
                                    key={item.id}
                                    className={`obg-item${selectedGenres.includes(item.id) ? " obg-checked" : ""}`}
                                    onClick={() => { toggleGenre(item.id); setBtnLit(true); setTimeout(() => setBtnLit(false), 600); }}
                                  >
                                    <div className="obg-checkbox">
                                      <svg className="obg-checkbox-tick" viewBox="0 0 10 10" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="1.5 5.5 4 8 8.5 2"/>
                                      </svg>
                                    </div>
                                    <span className="obg-item-label">{item.name}</span>
                                  </div>
                                ))}
                              </div>
                              <div className="col-md-6">
                                {rightCol.map((item: any) => (
                                  <div
                                    key={item.id}
                                    className={`obg-item${selectedGenres.includes(item.id) ? " obg-checked" : ""}`}
                                    onClick={() => { toggleGenre(item.id); setBtnLit(true); setTimeout(() => setBtnLit(false), 600); }}
                                  >
                                    <div className="obg-checkbox">
                                      <svg className="obg-checkbox-tick" viewBox="0 0 10 10" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="1.5 5.5 4 8 8.5 2"/>
                                      </svg>
                                    </div>
                                    <span className="obg-item-label">{item.name}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {/* See more / less */}
                      <div style={{ textAlign: "center", padding: "4px 0 12px" }}>
                        {Object.entries(groupedGenres).length > genresToShow ? (
                          <button className="obg-see-more" onClick={showMoreGenres} type="button">
                            <i className="fa-solid fa-chevron-down" style={{ fontSize: 11 }}/> See more categories
                          </button>
                        ) : genresToShow > 5 ? (
                          <button className="obg-see-more obg-see-less" onClick={showLessGenres} type="button">
                            <i className="fa-solid fa-chevron-up" style={{ fontSize: 11 }}/> See less
                          </button>
                        ) : null}
                      </div>

                      {/* Total selected badge */}
                      {selectedGenres.length > 0 && (
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
                          <div style={{
                            display: "inline-flex", alignItems: "center", gap: 7,
                            background: "#fff5f5", border: "1.5px solid rgba(192,0,26,.25)",
                            borderRadius: 999, padding: "7px 18px",
                            fontSize: 13, fontWeight: 700, color: "#c0001a",
                            fontFamily: "'Inter',sans-serif",
                          }}>
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="20 6 9 17 4 12"/>
                            </svg>
                            {selectedGenres.length} interest{selectedGenres.length !== 1 ? "s" : ""} selected
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div style={{ textAlign: "center", padding: "32px 0", color: "#94a3b8", fontFamily: "'Inter',sans-serif" }}>
                      No interests found for "<strong>{searchQuery}</strong>"
                    </div>
                  )}
                </div>
                <BotSpacer n={2} />

                {/* ── Footer buttons — Bot Step 3 anchor ── */}
                <div className="d-flex justify-content-between mt-4">
                  <button type="button" className="obg-btn-back" onClick={handleBack}>
                    <i className="fa-solid fa-arrow-left" style={{ fontSize: 12 }}/> Back
                  </button>
                  <div ref={refContinue}>
                    <button type="button" onClick={handleNext} className={`obg-btn-continue${btnLit ? " obg-lit" : ""}`}>
                      Continue <i className="fa-solid fa-arrow-right" style={{ fontSize: 12 }}/>
                    </button>
                  </div>
                </div>
                <BotSpacer n={3} />

              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GenresStep;